import { DividerSize, DividerOrientation } from './Divider.decl';
export var makeDividerSize = function makeDividerSize(props) {
  var _sizes, _orientations;

  var sizes = (_sizes = {}, _sizes[DividerSize.X_SMALL] = '1px', _sizes[DividerSize.SMALL] = '2px', _sizes);
  var size = sizes[props.size] || props.size;
  var orientations = (_orientations = {}, _orientations[DividerOrientation.VERTICAL] = {
    width: size,
    height: '100%'
  }, _orientations[DividerOrientation.HORIZONTAL] = {
    height: size,
    width: '100%'
  }, _orientations);
  return orientations[props.orientation];
}; // Props that should not be forwarded to the HTML DOM elements

export var shouldForwardProp = function shouldForwardProp(prop, defaultValidationFn) {
  return !['size', 'orientation'].includes(prop);
};